import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Meses from '../../services/Meses';

export default function MenuExtratos(props) {

  const meses = Meses;
  const location = useLocation();
  const mesAnterior = () => new Date().setMonth(new Date().getMonth() - 1);
  const [menu, setMenu] = useState(new Date(mesAnterior()).getMonth() + 1);
  const periodoRequest = location.state ? location.state.periodo : { 'mes_id': (new Date(new Date()).getMonth() + 1), 'ano': new Date(mesAnterior).getMonth() + 1 };

  useEffect(() => {
    handlerMenu(periodoRequest.mes_id);
  }, [location.state])

  const handlerMenu = (_mes_id) => {
    if (_mes_id != menu)
      setMenu(_mes_id);
  }

  const CatalogItem = (props) => {
    return (
      <>
        <ul className="ml-menu" style={{ display: 'block' }}>
          {meses.map(mes =>
            <li key={Math.random()} className={menu == mes.id ? 'active waves-rippling' : ''} >
              <Link to={'/'} key={Math.random()} state={{ periodo: { 'mes_id': mes.id, 'mes': mes.mes, 'ano': props.workspace }, 'key': Math.random() }} className={"waves-effect waves-classic"} style={{}} onClick={() => handlerMenu(mes.id)} >
                <span> {mes.mes} </span>
              </Link>
            </li>)}
        </ul >
      </>
    );
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          <li className="header"><strong> <i className='zmdi zmdi-calendar m-r-5'></i>  &nbsp;MESES </strong></li>
          <CatalogItem></CatalogItem>
        </ul>
      </div>
    </>
  );

}
